var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-horz-buttons"},[_c('h2',[_vm._v(" "+_vm._s(_vm.chartTitle("memoryAndHitRate"))+" ")]),_c('TimeRangeControls')],1),_c('ProcessedStatsChart',{attrs:{"chartID":"memoryAndHitRate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }